import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function LoginModal({ isOpen, onClose, setUser }) {
    const [mode, setMode] = useState("login");
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
    });

    if (!isOpen) return null;

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};

        // Validation
        if (mode === "register" && !form.name.trim()) {
            newErrors.name = "Full name is required";
        }

        if (!form.email.trim()) {
            newErrors.email = "Email is required";
        }

        if (!form.password.trim()) {
            newErrors.password = "Password is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            // REGISTER
            if (mode === "register") {
                await axios.post("https://beachhotelsdubai.com/api/register", {
                    name: form.name,
                    email: form.email,
                    password: form.password,
                    password_confirmation: form.password,
                });

                alert("User registered successfully");
                setMode("login");
                onClose();
            }

            // LOGIN
            if (mode === "login") {
                const res = await axios.post("https://beachhotelsdubai.com/api/login", {
                    email: form.email,
                    password: form.password,
                });

                const userData = res.data.user;

                // Save user
                localStorage.setItem("user", JSON.stringify(userData));
                setUser(userData);

                alert("Login successful");

                // ✅ CLOSE MODAL FIRST
                onClose();

                // ✅ REDIRECT TO PROFILE
                navigate("/profile");
            }

        } catch (err) {
            console.error(err);
            alert("Authentication failed");
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            <div className="bg-white w-[90%] max-w-md rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.15)] p-6 relative border border-[#0F172A]/20">

                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full hover:bg-orange-100 text-gray-500 hover:text-[#0F172A] transition"
                >
                    ✕
                </button>

                <h2 className="text-2xl font-bold text-center mb-6 bg-gradient-to-r from-[#0F172A] to-[#FF8C42] bg-clip-text text-transparent">
                    {mode === "register" ? "Create Account" : "Sign In"}
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">

                    {mode === "register" && (
                        <>
                            <input
                                name="name"
                                placeholder="Full Name"
                                onChange={handleChange}
                                className="w-full border border-gray-300 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0F172A] focus:border-[#0F172A] transition"
                            />
                            {errors.name && (
                                <p className="text-red-500 text-sm">{errors.name}</p>
                            )}
                        </>
                    )}

                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0F172A] focus:border-[#0F172A] transition"
                    />
                    {errors.email && (
                        <p className="text-red-500 text-sm">{errors.email}</p>
                    )}

                    <input
                        name="password"
                        type="password"
                        placeholder="Password"
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0F172A] focus:border-[#0F172A] transition"
                    />
                    {errors.password && (
                        <p className="text-red-500 text-sm">{errors.password}</p>
                    )}

                    <button className="w-full bg-gradient-to-r from-[#0F172A] to-[#FF8C42] text-white py-3 rounded-xl font-semibold hover:shadow-[0_10px_25px_rgba(255,107,53,0.25)] transition-all duration-300">
                        {mode === "register" ? "Register" : "Login"}
                    </button>
                </form>

                <div className="text-center mt-5 text-sm">
                    {mode === "login" ? (
                        <button onClick={() => setMode("register")}>
                            Create account
                        </button>
                    ) : (
                        <button onClick={() => setMode("login")}>
                            Back to login
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}